import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NamesToUpdateService } from '../../services/raintree/Transmission/names-to-update.service';
import { FWNamesResponse } from '../../services/raintree/interfaces/names-to-update.interface';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UserWishlistDialogComponent } from '../../views/common/user-wishlist-dialog/user-wishlist-dialog.component';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'fw-transfer-dialog',
  standalone: true,
  templateUrl: './fw-transfer-dialog.component.html',
  styleUrls: [
    './fw-transfer-dialog.component.scss',
    '../../../styles/_dropdown.scss',
  ],
  imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule],
})
export class FWTransferDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _namesToUpdateService : NamesToUpdateService, private dialogRef: MatDialogRef<FWTransferDialogComponent>, private dialog: MatDialog, private _toastr: ToastrService) {}
  fwNames: any= [];
  fwName = new FormControl('')
  districtName!: string;
  stateName!: string

  ngOnInit(): void {
    this.fwName.setValue('default')
    // this.districtName = localStorage.getItem('district')!;
    // this.stateName = localStorage.getItem('state')!;
    let queryParamsObj = {
      uiState: this.data.selectedState,
      uiDistrict: this.data.selectedDistrict,
      contactVerified: true
    };

    this._namesToUpdateService.getFWNames(queryParamsObj).subscribe({
      next: (response: FWNamesResponse) => {
        this.fwNames = response.data.map(
          (user: any) => {
            return {
              label: user.first_name + ' '+user.last_name,
              value: user.id,
              email: user.email_id
            };
          }
        );
      },
      error: (error) => console.log(error),
    });
  }

  transferWishlist() {
    console.log(this.fwName.value);

    let bodyObj = {
      uiState: this.data.selectedState,
      uiDistrict: this.data.selectedDistrict,
      wishlistId: this.data.id,
      userId: this.fwName.value
    }
    this._namesToUpdateService.transferWishlist(bodyObj).subscribe({
      next: (response: any) => {
        const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
          panelClass: 'common-pannel-dialog-container',
        data: {
          mainHeading: `Wishlist had been Transferred successfully!`,
          subHeading: 'Your can access all wish-lists from the ‘My wishlists’',
          buttonValue: 'Done'
         },
      })
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.dialogRef.close(true)
        }
      });

      },
      error: (error) => {
        this._toastr.error(error);
      },
    });
  }
}
